










import { Component, Vue } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import { IProcessingErrors } from '@/features/job/store'
import { GET_JOB_ERRORS_BY_PROJECT } from '@/system/store/getter-types'
import JobDetailsListByProject from '@/features/job/components/JobDetailsListByProject.vue'

@Component({
  components: {
    JobDetailsListByProject
  }
})
export default class JobDetailsList extends Vue {
  @Getter(GET_JOB_ERRORS_BY_PROJECT)
  errorsByProject!: { [key: string]: IProcessingErrors[] }
}
